import * as echarts from "echarts";
import { PieSeriesOption, TooltipComponentOption } from "echarts";

type ECOption = echarts.ComposeOption<PieSeriesOption | TooltipComponentOption>;

const colorList = [
  "#4CDE99",
  "#FDC151",
  "#33DFE4",
  "#8851FD",
  "#33B1FF",
  "#FF9245",
  "#FD5151",
  "#BDFD51",
  "#516AFD",
  "#B999D4",
  "#51FD84",
  "#FD51B8",
  "#FDFB51",
  "#51FDC5",
  "#E551FD",
  "#FF7717",
  "#009EFF",
  "#A87FC9",
  "#FDB225",
  "#00D7DD",
  "#00D16E"
];

export default (data: any[], color: string[] = colorList): ECOption => {
  return {
    series: [
      {
        type: "pie",
        clockwise: false,
        color,
        radius: ["35%", "60%"],
        label: {
          show: true,
          fontSize: 12,
          lineHeight: 18,
          color: "#111",
          formatter: "{b}",
          position: "left"
        },
        itemStyle: {
          borderWidth: 3,
          borderColor: "#F8f9fb",
          borderRadius: [6, 6]
        },
        emphasis: {
          scaleSize: 1
        },
        labelLine: {
          show: false,
          length: 10, //两段线 控制文字位置
          length2: 0
        },
        data
      }
    ]
  };
};
